import React, {useRef} from 'react';
import {
  Button,
  useDisclosure,
  useToast,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Tooltip,
} from '@chakra-ui/react';
import {useDeleteCustomerAccounts} from './hooks/customer';
import {Customer} from '../../shared/customer';
import {WithId} from '../../shared/util';

export const DeleteCustomerAccountsButton = ({
  customer,
}: {
  customer: WithId<Customer>;
}) => {
  const isPoc = customer.plan.type === 'poc';
  const {isOpen, onOpen, onClose} = useDisclosure();
  const cancelRef = useRef(null);
  const toast = useToast();
  const deleteCustomerAccounts = useDeleteCustomerAccounts();

  const handleDelete = () => {
    deleteCustomerAccounts.mutate(
      {customerId: customer._id},
      {
        onSuccess: () => {
          toast({
            title: 'Customer accounts deleted',
            status: 'success',
            duration: 5000,
            isClosable: true,
            position: 'bottom',
          });
          onClose();
        },
      }
    );
  };

  return (
    <>
      <Tooltip
        label="Only available for POCs"
        placement="top"
        isDisabled={isPoc}
      >
        <Button colorScheme="kred" onClick={onOpen} isDisabled={!isPoc}>
          Delete Accounts
        </Button>
      </Tooltip>

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete Customer Accounts
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure? This will delete all customer accounts. This action
              cannot be undone.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button
                colorScheme="kred"
                onClick={handleDelete}
                ml={3}
                isLoading={deleteCustomerAccounts.isPending}
              >
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};
